import { render, staticRenderFns } from "./ShopServe.vue?vue&type=template&id=afa8fa92&"
import script from "./ShopServe.vue?vue&type=script&lang=js&"
export * from "./ShopServe.vue?vue&type=script&lang=js&"
import style0 from "./ShopServe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports